import { Link } from 'react-router-dom';
import tyrlLogo from '../../assets/tyrl-logo.svg';

// Shared chrome for the public surface (public page, privacy, scan consent,
// results). Deliberately outside HubLayout / DashboardLayout — no role
// guards, no auth fetch on mount: these pages must render for strangers.
export function ProspectShell({ children }: { children: React.ReactNode }) {
  return (
    <div className="relative min-h-screen bg-surface-0 text-crux-light overflow-hidden">
      {/* pillar gradient line */}
      <div
        className="fixed top-0 inset-x-0 h-[2px] z-50"
        style={{
          background:
            'linear-gradient(90deg, #3D55D6 0%, #5B7CFF 33%, #9A988F 66%, #3FA96B 100%)',
        }}
      />

      {/* faint grid background */}
      <div
        aria-hidden
        className="pointer-events-none fixed inset-0 z-0"
        style={{
          backgroundImage:
            'linear-gradient(rgba(27,27,27,0.05) 1px, transparent 1px), linear-gradient(90deg, rgba(27,27,27,0.05) 1px, transparent 1px)',
          backgroundSize: '48px 48px',
        }}
      />

      {/* top bar */}
      <header className="relative z-40 px-10 py-5 flex items-center justify-between">
        <Link to="/">
          <img src={tyrlLogo} alt="TYRL" className="h-20 opacity-90" />
        </Link>
        <div className="text-[11px] font-medium uppercase tracking-[0.12em] text-neutral-500">
          OrgIQ · Salesforce org scan
        </div>
      </header>

      <main className="relative z-10 px-6 pb-24">{children}</main>

    </div>
  );
}
